export const GET_OPEN_SHIFTS = "GET_OPEN_SHIFTS";
export const GET_OPEN_SHIFTS_SUCCESS = "GET_OPEN_SHIFTS_SUCCESS";
export const GET_OPEN_SHIFTS_FAIL = "GET_OPEN_SHIFTS_FAIL";

export const DELETE_OPEN_SHIFTS = "DELETE_OPEN_SHIFTS";
export const DELETE_OPEN_SHIFTS_SUCCESS = "DELETE_OPEN_SHIFTS_SUCCESS";
export const DELETE_OPEN_SHIFTS_FAIL = "DELETE_OPEN_SHIFTS_FAIL";

export const ADD_OPEN_SHIFT = "ADD_OPEN_SHIFT";
export const ADD_OPEN_SHIFT_SUCCESS = "ADD_OPEN_SHIFT_SUCCESS";
export const ADD_OPEN_SHIFT_FAIL = "ADD_OPEN_SHIFT_FAIL";

export const UPDATE_OPEN_SHIFT = "UPDATE_OPEN_SHIFT";
export const UPDATE_OPEN_SHIFT_SUCCESS = "UPDATE_OPEN_SHIFT_SUCCESS";
export const UPDATE_OPEN_SHIFT_FAIL = "UPDATE_OPEN_SHIFT_FAIL";

export const OPEN_SHIFT_REQUEST_LIST = "OPEN_SHIFT_REQUEST_LIST";
export const OPEN_SHIFT_REQUEST_LIST_SUCCESS = "OPEN_SHIFT_REQUEST_LIST_SUCCESS";
export const OPEN_SHIFT_REQUEST_LIST_FAIL = "OPEN_SHIFT_REQUEST_LIST_FAIL";

export const ACCEPT_SHIFT_REQUEST = "ACCEPT_SHIFT_REQUEST";
export const ACCEPT_SHIFT_REQUEST_SUCCESS = "ACCEPT_SHIFT_REQUEST_SUCCESS";
export const ACCEPT_SHIFT_REQUEST_FAIL = "ACCEPT_SHIFT_REQUEST_FAIL";
